import type { QueryClient } from '@tanstack/react-query';
import type { Template } from './types';

/**
 * Mirror the API's variable-rename cascade into every cached template. The
 * editor seeds its store from the `['template', id]` query ONCE per template,
 * and a cached copy from before the rename would seed the old key — which the
 * next save rejects as "not in the library".
 */
export function renameVariableInCachedTemplates(qc: QueryClient, from: string, to: string) {
  qc.setQueriesData<Template>({ queryKey: ['template'] }, (t) =>
    t && {
      ...t,
      fields: t.fields.map((f) => (f.kind === 'variable' && f.key === from ? { ...f, key: to } : f)),
    },
  );
}

/** The server only deletes an unplaced variable; a cached placement is stale, so drop it. */
export function dropVariableFromCachedTemplates(qc: QueryClient, key: string) {
  qc.setQueriesData<Template>({ queryKey: ['template'] }, (t) =>
    t && { ...t, fields: t.fields.filter((f) => !(f.kind === 'variable' && f.key === key)) },
  );
}
